import React, { useEffect, useState, useCallback } from 'react';
import { FiCheckCircle, FiAlertCircle, FiX } from 'react-icons/fi';

const Toast = ({ message, type, onClose, duration = 3000 }) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleClose = useCallback(() => {
    setIsVisible(false);
    // Allow fade out animation before calling onClose
    setTimeout(onClose, 300);
  }, [onClose]);

  useEffect(() => {
    // Fade in animation
    setIsVisible(true);
    
    // Auto close after duration
    const timer = setTimeout(() => {
      handleClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, handleClose]);

  const getToastStyles = () => {
    const baseStyles = "fixed top-4 right-4 z-50 p-4 rounded-lg shadow-lg transform transition-all duration-300 flex items-center space-x-3 max-w-md";
    
    if (type === 'success') {
      return `${baseStyles} bg-green-50 border border-green-200 text-green-800`;
    } else if (type === 'error') {
      return `${baseStyles} bg-red-50 border border-red-200 text-red-800`;
    } else if (type === 'warning') {
      return `${baseStyles} bg-yellow-50 border border-yellow-200 text-yellow-800`;
    } else {
      return `${baseStyles} bg-blue-50 border border-blue-200 text-blue-800`;
    }
  };

  const getIcon = () => {
    if (type === 'success') {
      return <FiCheckCircle className="w-5 h-5 text-green-600 flex-shrink-0" />;
    } else if (type === 'error') {
      return <FiAlertCircle className="w-5 h-5 text-red-600 flex-shrink-0" />;
    } else if (type === 'warning') {
      return <FiAlertCircle className="w-5 h-5 text-yellow-600 flex-shrink-0" />;
    } else {
      return <FiCheckCircle className="w-5 h-5 text-blue-600 flex-shrink-0" />;
    }
  };

  return (
    <div
      className={`${getToastStyles()} ${
        isVisible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'
      }`}
    >
      {getIcon()}
      <p className="text-sm font-medium flex-1">{message}</p>
      <button
        onClick={handleClose}
        className="flex-shrink-0 p-1 hover:opacity-70 transition-opacity"
      >
        <FiX className="w-4 h-4" />
      </button>
    </div>
  );
};

export default Toast;
